import { useMemo } from 'react'
import { Edit } from '@material-ui/icons'

import { Input, Button, Table } from '@baseV2'
import { getInputType } from '@baseV2/composite/table/columns'
import { enquiryInputType, strings } from '@constants'

import { isInvalidValue } from './useServicedQuantityItems'
import { BasicDetailsCard, CardHeader, CardTitle, HeaderRight, EditBtn, UpdateBtn, ServicedTableWrapper } from './style'

const ServicedQuantityCard = ({
	editable = false,
	isEditMode,
	isSaving,
	isDirty,
	hasInvalid,
	orderItems,
	viewOrderItems,
	enterEditMode,
	setItemField,
	handleUpdate,
	setIsEditMode,
}) => {
	const items = isEditMode ? orderItems : viewOrderItems

	const columns = useMemo(
		() => [
			{ label: strings('name'), key: 'product_name' },
			{
				label: strings('quantity'),
				key: 'serviced_weight',
				renderer: (value, item) => {
					// Input type (unit) is shown AGAINST the quantity value, not the name. Short form
					// (MTR / PCS / NOS / KW / SET) keeps the suffix from crowding the input; WEIGHT
					// is in kg here, so it is not the helper's default MT.
					const unit = item?.input_type === enquiryInputType.WEIGHT ? 'KG' : getInputType(item?.input_type)
					if (isEditMode) {
						return (
							<Input
								type='number'
								small
								min='0.01'
								value={value ?? ''}
								onChange={(e) => setItemField(item?.item_id, 'serviced_weight', e.target.value)}
								error={isInvalidValue(value) ? strings('msg_wrong_value') : undefined}
								disabled={isSaving}
								rightIcon={unit}
							/>
						)
					}
					const hasQty = value != null && value !== ''
					return hasQty ? `${value} ${unit}` : '-'
				},
			},
			{
				label: strings('rate'),
				key: 'price_per_kg',
				renderer: (value, item) =>
					isEditMode ? (
						<Input
							type='number'
							small
							min='0.01'
							value={value ?? ''}
							onChange={(e) => setItemField(item?.item_id, 'price_per_kg', e.target.value)}
							error={isInvalidValue(value) ? strings('msg_wrong_value') : undefined}
							disabled={isSaving}
						/>
					) : (
						value ?? '-'
					),
			},
		],
		[isEditMode, isSaving, setItemField]
	)

	return (
		<BasicDetailsCard>
			<CardHeader>
				<CardTitle>{strings('serviced', 'quantity')}</CardTitle>
				<HeaderRight>
					{isEditMode ? (
						<>
							<Button
								variant='outline'
								type='danger'
								xs
								disabled={isSaving}
								onClick={() => {
									setIsEditMode(false)
								}}
							>
								{strings('cancel')}
							</Button>
							<UpdateBtn type='primary' xs disabled={isSaving || !isDirty || hasInvalid} onClick={handleUpdate}>
								{isSaving ? 'Saving...' : strings('update')}
							</UpdateBtn>
						</>
					) : (
						editable && (
							<EditBtn onClick={enterEditMode}>
								<Edit fontSize='small' />
								{strings('edit')}
							</EditBtn>
						)
					)}
				</HeaderRight>
			</CardHeader>

			<ServicedTableWrapper>
				<Table
					columns={columns}
					data={items}
					rowsToDisplay={items.length || 1}
					hideFooter
					rowClickable={false}
					emptyState={{ text: strings('no_data_found') }}
				/>
			</ServicedTableWrapper>
		</BasicDetailsCard>
	)
}

export default ServicedQuantityCard
